import { render, staticRenderFns } from "./UiList.vue?vue&type=template&id=56898f8c&scoped=true"
import script from "./UiList.vue?vue&type=script&lang=js"
export * from "./UiList.vue?vue&type=script&lang=js"
import style0 from "./UiList.vue?vue&type=style&index=0&id=56898f8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56898f8c",
  null
  
)

export default component.exports